import classNames from 'classnames';
import {
  checkIfStringIsZeroOrEmpty,
  isNullOrEmpty,
} from '../../../utils/StringUtils/StringUtils';

const SingleFilter = ({
  title,
  name,
  value,
  type = 'text',
  filter,
  setFilterValue,
  maxLength = 100,
  customClassName = '',
}) => {
  return (
    <div className="text-xs inline-block m-5">
      <div>{title}:</div>
      <div className="relative">
        <input
          maxLength={maxLength}
          value={checkIfStringIsZeroOrEmpty(filter[value])}
          type={type !== 'number' ? type : 'text'}
          onChange={(e) => setFilterValue(value, e.target.value, type)}
          className={classNames(
            'outline-none border-b border-blue-800 focus:border-blue-400 px-2',
            type === 'number' ? 'max-w-[4rem]' : 'max-w-[7.5rem]',
            filter[value] && 'pr-6',
            customClassName,
          )}
          placeholder={`${name}...`}
        />
        {!isNullOrEmpty(filter[value]) && (
          <button
            type="button"
            onClick={() => setFilterValue(value, '', type)}
            className="absolute right-1 top-1/2 -translate-y-1/2 text-blue-500 hover:text-gray-700"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default SingleFilter;
